import React from 'react';

var MobileNavigationRow = function (_a) {
    var name = _a.name, icon = _a.icon, isDisabled = _a.isDisabled, onClick = _a.onClick;
    return (React.createElement("div", { className: "pgc-nav-row ".concat(isDisabled ? 'disabled' : ''), onClick: onClick },
        React.createElement("div", { className: 'pgc-nav-row-icon-b' },
            React.createElement("i", { className: icon })),
        React.createElement("p", { className: 'pgc-nav-row-txt' }, name)));
};

export { MobileNavigationRow };
